import { BoxProps, Input as ChakraInput } from '@chakra-ui/react'
import { withShade } from './utils'

export const Input = withShade<BoxProps>(ChakraInput)
